enum Role {
  SuperAdmin = 'Super_Admin',
  Admin = 'Admin',
  WriterFull = 'Write_All',
  ReaderFull = 'Read_All',
  Custom = 'Custom'
}

export { Role };
